/**
 * WOLV Cart Drawer Hook
 * Intercepts every /cart/add.js POST sitewide, injects the sections param
 * so Shopify returns rendered cart-drawer + cart-icon-bubble HTML in the
 * response, and then triggers cartDrawer.renderContents() so the drawer
 * slides out with the fresh item and the header count updates immediately.
 *
 * This means individual product sections don't need to know about the
 * drawer. Their existing fetch('/cart/add.js') calls "just work."
 */
(function() {
  if (window.__wolvCartHookLoaded) return;
  window.__wolvCartHookLoaded = true;

  var SECTIONS_PARAM = 'cart-drawer,cart-icon-bubble';

  function isCartAddUrl(url) {
    if (!url) return false;
    var u = typeof url === 'string' ? url : (url.url || '');
    return u.indexOf('/cart/add') !== -1;
  }

  function injectSectionsIntoInit(init) {
    if (!init || !init.body) return init;
    try {
      var body = init.body;
      if (typeof body === 'string' && body.charAt(0) === '{') {
        var parsed = JSON.parse(body);
        if (!parsed.sections) {
          parsed.sections = SECTIONS_PARAM;
          parsed.sections_url = window.location.pathname;
          init.body = JSON.stringify(parsed);
        }
      } else if (typeof FormData !== 'undefined' && body instanceof FormData) {
        if (!body.has('sections')) {
          body.append('sections', SECTIONS_PARAM);
          body.append('sections_url', window.location.pathname);
        }
      } else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        if (!body.has('sections')) {
          body.append('sections', SECTIONS_PARAM);
          body.append('sections_url', window.location.pathname);
        }
      }
    } catch (e) { /* leave body untouched on parse errors */ }
    return init;
  }

  function triggerDrawer(parsedState) {
    if (!parsedState || !parsedState.sections) return;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents(parsedState);
    }
  }

  var originalFetch = window.fetch;
  window.fetch = function(input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isAdd = isCartAddUrl(url);
    if (isAdd) init = injectSectionsIntoInit(init || {});
    var promise = originalFetch.call(this, input, init);
    if (!isAdd) return promise;
    return promise.then(function(response) {
      if (!response || !response.ok) return response;
      try {
        response.clone().json().then(triggerDrawer).catch(function() {});
      } catch (e) {}
      return response;
    });
  };

  /**
   * Native form-submit interceptor.
   * Any <form action="/cart/add"> that isn't already handled by a
   * page-specific script (via preventDefault) is intercepted here,
   * converted to an AJAX POST, and — because the fetch above will
   * catch that POST — routed through the drawer-open flow.
   * Falls back to native submit on failure so nothing gets stranded.
   */
  document.addEventListener('submit', function(evt) {
    if (evt.defaultPrevented) return;
    var form = evt.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (typeof FormData === 'undefined' || typeof window.fetch === 'undefined') return;

    evt.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    var origLabel = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.dataset.wolvOrigLabel = origLabel;
    }

    var formData = new FormData(form);
    // Match Ascend's behavior — an empty selling_plan should be a one-time purchase
    if (formData.has('selling_plan') && !formData.get('selling_plan')) {
      formData.delete('selling_plan');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).then(function(r) {
      return r.json().then(function(data) { return { ok: r.ok, data: data }; });
    }).then(function(res) {
      if (submitBtn) {
        setTimeout(function() {
          submitBtn.disabled = false;
          submitBtn.textContent = origLabel;
        }, 1500);
      }
      if (!res.ok) {
        // On Shopify error (out of stock, etc.) fall back to native form submit so user sees the error page
        form.submit();
      }
    }).catch(function() {
      // Network failure — fall back to native submit
      if (submitBtn) submitBtn.disabled = false;
      form.submit();
    });
  }, false);

  /**
   * Sticky ATC redirect. Any button on a product page that looks like a
   * sticky-bar ATC (class *sticky__btn* or data-satc-trigger) should
   * scroll the user to the buy block so they can pick one-time vs
   * subscribe & save — never auto-add to cart with the default
   * subscription frequency.
   *
   * Runs at capture phase so it fires BEFORE any inline onclick handler
   * on the same button (e.g. `onclick="acAtc.click()"`), and calls
   * stopImmediatePropagation() to cancel those inline handlers.
   */
  function isStickyBuyButton(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.matches('[data-satc-trigger]')) return true;
    var cls = el.className || '';
    if (typeof cls !== 'string') return false;
    return /sticky__btn|-sticky-btn|wolv-sticky/i.test(cls);
  }

  function findBuyBlock() {
    return (
      document.querySelector('[id$="-buy"]') ||
      document.getElementById('wolv-buy') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  document.addEventListener('click', function(evt) {
    var btn = evt.target.closest ? evt.target.closest('button, a, [role="button"]') : null;
    if (!btn || !isStickyBuyButton(btn)) return;
    // Skip if it's the primary in-block ATC (inside a product form).
    if (btn.closest('form[action*="/cart/add"]')) return;
    var target = findBuyBlock();
    if (!target) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, true);
})();
